<template>
  <div :class="iconClass" :style="iconStyle" v-html="iconContent"></div>
</template>

<script>
  import { defineComponent, ref, watch } from 'vue';

  export default defineComponent({
    name: 'BaseIcon',
    props: {
      name: {
        type: String,
        required: true,
      },
      size: {
        type: [String, Number],
        default: '16',
      },
    },
    setup(props) {
      const iconContent = ref('');

      const loadIcon = async (iconName) => {
        try {
          // Use glob imports for production build support
          const icons = import.meta.glob('@shared/assets/icons/*.svg', {
            query: '?raw',
            import: 'default',
            eager: false,
          });

          const iconPath = `/shared/assets/icons/${iconName}.svg`;
          if (!(iconPath in icons)) {
            console.error(`Icon ${iconName} not found in available icons`);
            iconContent.value = '';
            return;
          }

          const icon = await icons[iconPath]();
          iconContent.value = icon;
        } catch (error) {
          console.error(error);
          iconContent.value = '';
        }
      };

      watch(
        () => props.name,
        (newName) => {
          loadIcon(newName);
        },
        { immediate: true }
      );

      const iconClass = ref('icon');
      const iconStyle = ref({
        width: `${props.size}px`,
        height: `${props.size}px`,
      });

      return {
        iconContent,
        iconClass,
        iconStyle,
      };
    },
  });
</script>

<style lang="scss">
  .icon {
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    svg {
      display: inline-block;
      fill: currentColor;
      width: 100%;
      height: 100%;
    }
  }
</style>
